import Config from '~/client/src/shared/Config'
import ApiHelper from '~/client/src/shared/utils/ApiHelper'

export interface IWorkflowSummaryField {
  name: string
  type: string
  values: any[]
}

interface IWorkflowSummaryStep {
  name: string
  type: string
  fields: IWorkflowSummaryField[]
}

export interface IWorkflowSummaryRequest {
  kind: 'workflow' | 'sitePermit'
  data: {
    title?: string
    workflowName?: string
    code?: string
    status?: string
    startDate?: string
    endDate?: string
    currentStepName?: string
    currentStepType?: string
    fields: IWorkflowSummaryField[]
    steps: IWorkflowSummaryStep[]
  }
}

export interface IWorkflowSummaryUsage {
  promptTokens: number
  completionTokens: number
  totalTokens: number
  model: string
  costUsd: number
}

export type WorkflowSummaryModelId = 'gpt-5.4-nano' | 'gemini-2.5-flash'

export const WORKFLOW_SUMMARY_MODELS: {
  id: WorkflowSummaryModelId
  label: string
}[] = [
  { id: 'gpt-5.4-nano', label: 'GPT-5.4 Nano' },
  { id: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash' },
]

interface IWorkflowSummaryCompact {
  prose: string
  warning_count: number
  warnings: string[]
}

interface IWorkflowSummaryResponse {
  headline: string
  status: string
  facts: string[]
  summary: string
  flags: string[]
  compact: IWorkflowSummaryCompact
  usage: IWorkflowSummaryUsage
}

export default class WorkflowSummaryService {
  public static async summarize(
    input: IWorkflowSummaryRequest,
    model?: WorkflowSummaryModelId,
  ): Promise<IWorkflowSummaryResponse> {
    const baseUrl = Config.WORKFLOW_AI_BACKEND_URL?.replace(/\/$/, '')

    if (!baseUrl) {
      throw new Error('AI summary is not configured')
    }

    const headers: Record<string, string> = {
      'content-type': 'application/json',
    }

    const token = Config.WORKFLOW_AI_BACKEND_TOKEN
    if (token) {
      headers.authorization = `Bearer ${token}`
    }

    const response = await fetch(`${baseUrl}/summarize`, {
      method: 'POST',
      headers,
      body: JSON.stringify(model ? { ...input, model } : input),
    })

    const { data, isSuccess } = await ApiHelper.toResponseData(response)

    if (!isSuccess) {
      throw new Error(
        typeof data === 'string' ? data : data?.error || 'Failed to summarize',
      )
    }

    return data
  }
}
